<div class="sidebar-container">
  <div rtScrollable class="sidebar" [class.has-border-radius]="hasBorderRadius()">
    <ng-content />
  </div>

  @if (hasExpander()) {
    <div (click)="toggleSidebar(!isExpanded())" class="expander">
      @if (!isMinimized() && enableExpanderShortcuts()) {
        <div class="hotkey-controls-group">
          <div class="symbol-wrapper" margin-right-small-xx>
            <span margin-lr-small-xxx>[</span>
          </div>
          <div class="symbol-wrapper">
            <span margin-lr-small-xxx>]</span>
          </div>
          <div class="label">{{ 'app.sidebar.show_hide' | translate }}</div>
        </div>
      }
      <rt-icon [name]="isExpanded() ? 'chevron-left' : 'chevron-right'" />
    </div>
  }
</div>
